/* GUAPI SUMMER SALE 2026 - cart feedback v5 (production).
   v5: header cart badge (.cart-count-badge) gets the count AND loses its 'hidden' class
   when items exist - the number is now visible top-right after every add. */
(function(){
  function beacon(s){
    try { fetch('https://guapi-pnl.guapi-ops.workers.dev/etalog?s=' + encodeURIComponent(String(s).slice(0,175))); } catch(e){}
  }
  function toast(msg, bad){
    var t = document.getElementById('gp-toast');
    if (!t) { t = document.createElement('div'); t.id = 'gp-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.className = bad ? 'bad show' : 'show';
    clearTimeout(t._h);
    t._h = setTimeout(function(){ t.className = ''; }, 3200);
  }
  function refreshDrawer(){
    return fetch('/?sections=cart-drawer').then(function(r){return r.json()}).then(function(s){
      var html = s && s['cart-drawer'];
      if (!html) return;
      var cur = document.querySelector('cart-drawer');
      if (!cur) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('cart-drawer');
      if (next) cur.innerHTML = next.innerHTML;
    }).catch(function(e){ beacon('DRAWER refresh-err ' + e); });
  }
  function refreshCount(){
    return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      var n = c.item_count || 0;
      beacon('CART count=' + n);
      document.querySelectorAll('.cart-count-badge').forEach(function(el){
        el.textContent = n > 0 ? n : '';
        if (n > 0) el.classList.remove('hidden'); else el.classList.add('hidden');
      });
      document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function(el){
        if (el.children.length === 0) el.textContent = n;
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', n);
      });
      var tc = document.querySelector('.cart-drawer__title-counter');
      if (tc) tc.textContent = n;
      return n;
    }).catch(function(e){ beacon('CART count-err ' + e); return null; });
  }
  window.gpCartAdd = function(items, cb){
    var ids = items.map(function(i){return i.id}).join(',');
    beacon('ADD try ids=' + ids);
    var fd = new URLSearchParams();
    for (var i=0;i<items.length;i++){
      fd.append('items['+i+'][id]', items[i].id);
      fd.append('items['+i+'][quantity]', items[i].quantity || 1);
    }
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'XMLHttpRequest'}, body: fd.toString()})
      .then(function(r){
        return r.text().then(function(tx){ return { ok: r.ok, status: r.status, tx: tx }; });
      })
      .then(function(res){
        beacon('ADD resp status=' + res.status);
        if (!res.ok) {
          var msg = 'Could not add to cart';
          try { var j = JSON.parse(res.tx); msg = j.description || j.message || msg; } catch(e){}
          throw new Error(msg);
        }
        return Promise.all([refreshCount(), refreshDrawer()]);
      })
      .then(function(rs){
        var n = rs[0];
        toast('\u2713 Added to cart' + (n ? ' \u00b7 ' + n + ' item' + (n>1?'s':'') : ''));
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e){}
        cb && cb(null, n);
      })
      .catch(function(err){
        beacon('ADD fail ' + ((err && err.message) || err));
        toast('\u2715 ' + ((err && err.message) || 'Could not add to cart'), true);
        cb && cb(err);
      });
  };
  beacon('gpCartAdd loaded v5');
})();
